export default __webpack_public_path__ + "static/media/streak-tier-3.39bd6863.png";